import Vue from "vue";
import Notification from "./Notifications";

Vue.notify = Notification;

Vue.use(Notification);
